export default __webpack_public_path__ + "static/media/provinces.cf726ac3.yml";